module.exports = __webpack_public_path__ + "img/filters-ductwork-cleaned-02.923fe69d.jpg";